import React, { useState, useEffect } from "react";
import I from "../component/Icon";
import BC from "./Breadcrumb";
import Bdg from "../component/Badge";
import apiService from "../services/apiService";

export default function CenterView({ center, onBack, onEdit }) {
  const [centerData, setCenterData] = useState(center);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCenterDetails = async () => {
      try {
        setLoading(true);
        setError("");

        // Fetch center by ID + master data using apiService
        const [
          centerRes,
          talukaRes,
          capacityRes,
        ] = await Promise.all([
          apiService.get(
            `Center/getCenterById/${center.id}`
          ),
          apiService.get(
            "TalukaMaster/getAllTalukaMasters"
          ),
          apiService.get(
            "Capacity/getAllCapacity"
          ),
        ]);

        const centerResponse =
          centerRes?.data;

        const talukaResponse =
          talukaRes?.data;

        const capacityResponse =
          capacityRes?.data;

        const c =
          centerResponse?.output ??
          centerResponse?.Output ??
          centerResponse?.data ??
          centerResponse?.Data ??
          centerResponse;

        const talukaList =
          talukaResponse?.output ??
          talukaResponse?.Output ??
          talukaResponse?.data ??
          talukaResponse?.Data ??
          [];

        const capacityList =
          capacityResponse?.output ??
          capacityResponse?.Output ??
          capacityResponse?.data ??
          capacityResponse?.Data ??
          [];

        if (!c) {
          throw new Error(
            "Center details not found."
          );
        }

        // Create lookup maps
        const talukaMap =
          Object.fromEntries(
            (Array.isArray(talukaList)
              ? talukaList
              : []
            ).map((t) => [
              t?.id ?? t?.Id,
              t?.talukaName ??
                t?.TalukaName ??
                "",
            ])
          );

        const capacityMap =
          Object.fromEntries(
            (Array.isArray(capacityList)
              ? capacityList
              : []
            ).map((item) => {
              const id =
                item?.id ??
                item?.Id;

              const name =
                item?.name ??
                item?.Name ??
                "";

              const parts =
                String(name).split("-");

              const value =
                Number(parts[1]) || 0;

              return [
                id,
                {
                  name,
                  value,
                },
              ];
            })
          );

        const talukaId =
          c?.talukaId ??
          c?.TalukaId;

        const capacityId =
          c?.capacityId ??
          c?.CapacityId;

        // Merge names into center
        const mappedCenter = {
          ...c,

          id:
            c?.id ??
            c?.Id ??
            center?.id ??
            center?.Id,

          name:
            c?.name ??
            c?.Name ??
            "",

          city:
            talukaMap[talukaId] || "",

          state: "Maharashtra",

          capacity:
            capacityMap[capacityId]?.name ||
            "",

          capacityValue:
            capacityMap[capacityId]?.value ||
            0,

          assigned:
            c?.assigned ??
            c?.Assigned ??
            0,

         

          address:
            c?.address ??
            c?.Address ??
            "",

          contact:
            c?.contact ??
            c?.Contact ??
            "",

          talukaId,

          capacityId,

          districtId:
            c?.districtId ??
            c?.DistrictId ??
            0,

          stateId:
            c?.stateId ??
            c?.StateId ??
            1,
        };

        setCenterData(mappedCenter);
      } catch (err) {
        console.error(
          "Error fetching center details:",
          err
        );

        const backendData =
          err?.response?.data;

        let message =
          "Unable to load center details. Please try again.";

        if (
          backendData?.errors &&
          typeof backendData.errors === "object"
        ) {
          const validationMessage =
            Object.values(
              backendData.errors
            )
              .flat()
              .join(" ");

          if (validationMessage) {
            message =
              validationMessage;
          }
        } else {
          message =
            backendData?.failureReason ??
            backendData?.FailureReason ??
            backendData?.message ??
            backendData?.Message ??
            err?.message ??
            message;
        }

        setError(message);
      } finally {
        setLoading(false);
      }
    };

    if (
      center?.id ??
      center?.Id
    ) {
      fetchCenterDetails();
    } else {
      setError(
        "Center ID is missing."
      );
      setLoading(false);
    }
  }, [center?.id, center?.Id]);

  // Loading
  if (loading) {
    return (
      <div
        className="card"
        style={{
          padding: "30px",
          textAlign: "center",
        }}
      >
        Loading center details...
      </div>
    );
  }

  // Error
  if (error) {
    return (
      <div
        className="card"
        style={{
          padding: "30px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            color: "#dc2626",
            marginBottom: "15px",
          }}
        >
          {error}
        </div>

        <button
          className="btn btn-p"
          onClick={onBack}
        >
          Back
        </button>
      </div>
    );
  }

  const pct =
    centerData.capacityValue
      ? Math.round(
          (centerData.assigned /
            centerData.capacityValue) *
            100
        )
      : 0;

  const st =
    centerData.assigned >=
    centerData.capacityValue
      ? "full"
      : centerData.capacityValue &&
        centerData.assigned /
          centerData.capacityValue >
          0.8
      ? "high"
      : "ok";

  return (
    <>
      <BC
        items={[
          "Centers",
          centerData.name,
        ]}
        onBack={onBack}
      />

      <div
        style={{
          display: "flex",
          gap: 14,
          flexWrap: "wrap",
        }}
      >
        {/* LEFT CARD */}
        <div
          style={{
            flex: "0 0 250px",
          }}
        >
          <div className="card cp">
            <div
              style={{
                width: 40,
                height: 40,
                background: "#EFF6FF",
                borderRadius: 9,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 10,
              }}
            >
              <I
                n="center"
                s={19}
                c="var(--p)"
              />
            </div>

            <div
              style={{
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              {centerData.name}
            </div>

            <div
              style={{
                fontSize: 12,
                color: "var(--t3)",
                marginTop: 2,
              }}
            >
              {centerData.city},{" "}
              {centerData.state}
            </div>

            <div
              style={{
                marginTop: 8,
              }}
            >
              {st === "full" ? (
                <Bdg
                  type="red"
                  label="Full"
                />
              ) : st === "high" ? (
                <Bdg
                  type="yellow"
                  label="High"
                />
              ) : (
                <Bdg
                  type="green"
                  label="Available"
                />
              )}
            </div>

            {/* OCCUPANCY — KEEPING 0 FOR NOW */}
            <div
              style={{
                marginTop: 11,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "space-between",
                  marginBottom: 4,
                }}
              >
                <span
                  style={{
                    fontSize: 11.5,
                    color: "var(--t3)",
                  }}
                >
                  Occupancy
                </span>

                <span
                  style={{
                    fontSize: 11.5,
                    fontWeight: 700,
                  }}
                >
                  {pct}%
                </span>
              </div>

              <div
                className="pw"
                style={{
                  height: 7,
                }}
              >
                <div
                  className={`pf ${
                    pct >= 100
                      ? "pr"
                      : pct > 80
                      ? "py"
                      : "pg"
                  }`}
                  style={{
                    width: `${Math.min(
                      pct,
                      100
                    )}%`,
                  }}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "space-between",
                  marginTop: 4,
                  fontSize: 10.5,
                  color: "var(--t3)",
                }}
              >
                <span>
                  {centerData.assigned}{" "}
                  assigned
                </span>

                <span>
                  {centerData.capacity}{" "}
                  total
                </span>
              </div>
            </div>

            <button
              className="btn btn-p"
              style={{
                width: "100%",
                marginTop: 13,
                justifyContent: "center",
              }}
              onClick={() =>
                onEdit(centerData)
              }
            >
              <I
                n="edit"
                s={12}
                c="#fff"
              />{" "}
              Edit Center
            </button>
          </div>
        </div>

        {/* RIGHT CARD */}
        <div
          style={{
            flex: 1,
          }}
        >
          <div className="card cp">
            <div
              className="fgrid"
              style={{
                gap: 9,
              }}
            >
              {[
                [
                  "Name",
                  centerData.name,
                ],
                [
                  "City",
                  centerData.city,
                ],
                [
                  "State",
                  centerData.state ||
                    "—",
                ],
                [
                  "Address",
                  centerData.address ||
                    "—",
                ],
                [
                  "Capacity",
                  centerData.capacity,
                ],
                [
                  "Assigned",
                  centerData.assigned,
                ],
              
                [
                  "Contact",
                  centerData.contact ||
                    "—",
                ],
              ].map(([k, v]) => (
                <div
                  key={k}
                  className="vf"
                >
                  <div className="vfl">
                    {k}
                  </div>

                  <div
                    className="vfv"
                    style={{
                      fontSize: 12.5,
                    }}
                  >
                    {v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}